import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface Inventory {
  inventory_id: number
  position: number
  source_location_id: number | null
  source_location_name: string | null
  quantity: number
  inventory_type_name: string
  inventory_sub_type_name: string
}

interface Item {
  id: number
  position: number
  pickupLocation: string
  quantity: number
  name: string
  inventorySubTypeName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JobStops',
  props: {
    destinationName: null,
    inventory: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { destinationName?: string, inventory: Inventory[] }



const stops = computed(() => {
  const items = props.inventory.map(
    (inv) =>
      ({
        id: inv.inventory_id,
        position: inv.position,
        pickupLocation: inv.source_location_name,
        quantity: inv.quantity,
        name: inv.inventory_type_name,
        inventorySubTypeName: inv.inventory_sub_type_name,
      } as Item)
  )

  return items
    .reduce((agg, item) => {
      let group = agg[item.position]
      if (!group) {
        group = {
          groupId: `${item.position}__${item.pickupLocation}`,
          pickupLocation: item.pickupLocation ?? 'Pickup location undecided',
          items: [],
        }
        agg[item.position] = group
      }
      group.items.push(item)
      return agg
    }, [] as { groupId: `${number}__${string}`; pickupLocation: string; items: Item[] }[])
    .filter(Boolean)
})

return { __sfc: true,props, stops }
}

})